import { useTranslation } from 'react-i18next';

import type { Dispatch, SetStateAction } from 'react';

import FilterOptionsLoader from '@/components/shared/loader/filter-options-loader';
import CheckboxWithLabel from '@/components/ui/checkbox-with-label';
import useGetStationListData from '@/hooks/use-get-station-list-data';

interface StationAccordionContentProps {
  selectedStations: string[];
  setSelectedStations: Dispatch<SetStateAction<string[]>>;
}

const StationAccordionContent = ({
  selectedStations,
  setSelectedStations,
}: StationAccordionContentProps) => {
  const { t } = useTranslation();
  const { data: stationList, isLoading: isStationListLoading } = useGetStationListData();

  const handleStationsChange = (id: string) => {
    setSelectedStations((prevStations) => {
      if (prevStations.includes(id)) {
        return prevStations.filter((stationId) => stationId !== id);
      }

      return [...prevStations, id];
    });
  };

  if (isStationListLoading) {
    return <FilterOptionsLoader />;
  }

  if (!stationList?.length) {
    return <div className="p-2 text-sm text-gray-500">{t('errors.stations.empty')}</div>;
  }

  return (
    <div className="flex flex-col text-balance">
      {stationList.map(({ designationOfficial, id: stopId }) => (
        <div
          className="flex items-center px-1 py-2 hover:bg-accent rounded"
          key={`incident-filter-${designationOfficial}`}
        >
          <CheckboxWithLabel
            id={stopId}
            checked={selectedStations.includes(stopId)}
            className="data-[state=checked]:border-primary data-[state=checked]:bg-primary"
            onCheckedChange={() => handleStationsChange(stopId)}
            text={designationOfficial}
          />
        </div>
      ))}
    </div>
  );
};

export default StationAccordionContent;
